export const truncateString = (input: string, maxLength: number) =>
  input.length > maxLength ? `${input.substring(0, maxLength)}...` : input;

export const removeLeadingSlash = (str: string) => str.replace(/^\\/g, '');
